export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-food-6764e13ddce696a0c9cfa66e0074bbd3.jpg";